<section class="cmn-innerpage-wrapper invoice">
  <div class="head">
    <div class="search-wrapper">
      <input
        type="text"
        class="cmn-header-search"
        placeholder="Search"
        (input)="onSearch($event)"
      />
    </div>

    <div class="form-wrapper" style="padding-top: 10px;">
      <form [formGroup]="dateRangeForm">
        <mat-form-field>
          <mat-date-range-input
            [rangePicker]="picker"
            [dateFilter]="dateFilter"
          >
            <input
              matStartDate
              placeholder="Start date"
              formControlName="startDate"
              (dateInput)="onDateChange($event, 'start')"
            />
            <input
              matEndDate
              placeholder="End date"
              formControlName="endDate"
              (dateInput)="onDateChange($event, 'end')"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </form>
    </div>
    <div>
      <h6 class="cmn-popup-heading" (click)="onClear()">
        <span>Clear&nbsp;Filter</span>
      </h6>
    </div>
    <button class="cmn-add-btn" (click)="navigateTo('invoice/invoice-new')" *ngIf="canCreateInvoice$ | async">
      <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> New Invoice
    </button>
  </div>
  <div class="inner-content">
    <ag-grid-angular
      style="width: 100%"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowSelection]="rowSelection"
      [suppressRowClickSelection]="true"
      [paginationPageSizeSelector]="paginationPageSizeSelector"
      [class]="themeClass"
      (cellClicked)="onCellClicked($event)"
    />
  </div>
  <div class="pagination-wrapper">
    <div class="page-size">
      <label for="pageSize">Page Size:</label>
      <select
        id="pageSize"
        [(ngModel)]="pageSize"
        (change)="onPageSizeChange($event)"
      >
        <option *ngFor="let size of pageSizeOptions" [value]="size">
          {{ size }}
        </option>
      </select>
    </div>
    <div class="page-nav" *ngIf="totalPages > 1">
      <button class="prev" (click)="prevPage()" [disabled]="page === 0">
        <img
          src="../../../assets/images/icons/arrow.svg"
          alt="prev arrow"
          srcset=""
        />
      </button>
      <span> Page {{ page + 1 }} of {{ totalPages }} </span>
      <button
        class="next"
        (click)="nextPage()"
        [disabled]="page + 1 >= totalPages"
      >
        <img
          src="../../../assets/images/icons/arrow.svg"
          alt="next arrow"
          srcset=""
        />
      </button>
    </div>
  </div>
</section>
